/**
 * ? @description : Students Tab Component
 */

// Dependencies
import React, { useState, useEffect } from "react";
import MUIDataTable, { TableFilterList } from "mui-datatables";
import { Dropdown } from "react-bootstrap";
import { Chip, CircularProgress, Typography } from "@mui/material";
import { useDispatch } from "react-redux";

// Axios Component
import Axios from "../../../../axios/Axios";

// MUI Icons
import MoreVertIcon from "@mui/icons-material/MoreVert";

// Modal Components
import ModalOpen from "./modals/StudentModalOpen";
import DeleteStudentModal from "./modals/DeleteStudentModal";
import CommentsModalReuse from "../../../Reusable/CommentsModalReuse";
import { ShowFullText } from "../../../Reusable/ShowMoreText";

// Redux Component
import { showSnackbar } from "../../../redux/features/appSlice";

import StudentAudioModal from "./modals/StudentAudioModal";
import axios from "axios";

function StudentsTab() {
  // * Redux
  const dispatch = useDispatch();

  // * State Variables
  const [studentsData, setStudentsData] = useState([]);
  const [tableData, setTableData] = useState([]);
  const [nameModal, setNameModal] = useState(false);
  const [commentModal, setCommentModal] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);
  //added by Ramanan on 08-11-2022
  const [isDataFetchError, setIsDataFetchError] = useState(false);
  
  // for comment section 
  const [reloadComments, setReloadComments] = useState(false);
  const handleCommentsModalClose = () => {
    setReloadComments(!reloadComments);
  };

    // for pagination state 
    const [rowsPerPage, setRowsPerPage] = useState(5);
    const handleRowsPerPageChange = (newRowsPerPage) => {
      setRowsPerPage(newRowsPerPage);
    };
  // * Columns Declaration for the Table
  const columns = [
    {
      name: "student_id",
      label: "Id",
      options: {
        display:false,
        filter: false,
        filterType: "dropdown",
      },
    },
    {
      name: "student_name",
      label: "Name",
      options: {
        filter: false,
        filterType: "dropdown",
        customBodyRender: (value) => {
          return (
            <div
              style={{ color: "blue", textTransform: "capitalize", cursor: "pointer" }}
              onClick={(value) => {
                setNameModal(true);
              }}
            >
              {value}
            </div>
          );
        },
      },
    },
    {
      name: "whatsappno",
      label: "WhatsApp Mobile",
      options: {
        filter: false,
        filterType: "dropdown",
      },
    },
    {
      name: "spoken_languages",
      label: "Languages",
      options: {
        filter: false,
        filterType: "dropdown",
      },
    },
    {
      name: "sponser_name",
      label: "Sponsor Name",
      options: {
        filter: false,
        filterType: "dropdown",
      },
    },
    {
      name: "sponser_contactno",
      label: "Sponsor Mobile",
      options: {
        filter: false,
        filterType: "dropdown",
      },
    },
    {
      name: "sponser_address",
      label: "Sponsor Address",
      options: {
        filter: false,
        filterType: "dropdown",
      },
    },
    // {
    //   name: "group_status",
    //   label: "Group Status",
    //   options: {
    //     filter: true,
    //     display: false,
    //     filterType: "checkbox",
    //     customBodyRender: (value) => {
    //       return (
    //         <div>
    //           {value === "grouped" ? (
    //             <div
    //               style={{
    //                 backgroundColor: "#66E150",
    //                 color: "black",
    //                 padding: "5px",
    //                 borderRadius: "5px",
    //                 opacity: "0.8",
    //                 textAlign: "center",
    //               }}
    //             >
    //               Grouped
    //             </div>
    //           ) : (
    //             <div
    //               style={{
    //                 backgroundColor: "#F34848",
    //                 color: "white",
    //                 padding: "5px",
    //                 borderRadius: "5px",
    //                 opacity: "0.8",
    //                 textAlign: "center",
    //               }}
    //             >
    //               Ungrouped
    //             </div>
    //           )}
    //         </div>
    //       );
    //     },
    //   },
    // },
    {
      name: "student_mapped_status",
      label: "Student Mapped Status",
      options: {
        filter: true,
        filterType: "checkbox",
        customBodyRender: (value) => {
          return (
            <div>
              {value === "mapped" ? (
                <div
                  style={{
                    backgroundColor: "#66E150",
                    color: "black",
                    padding: "5px",
                    borderRadius: "5px",
                    opacity: "0.8",
                    textAlign: "center",
                  }}
                >
                  Mapped
                </div>
              ) : (
                <div
                  style={{
                    backgroundColor: "#F34848",
                    color: "white",
                    padding: "5px",
                    borderRadius: "5px",
                    opacity: "0.8",
                    textAlign: "center",
                  }}
                >
                  Unmapped
                </div>
              )}
            </div>
          );
        },
      },
    },
    // {
    //   name: "mapped_to_teacher",
    //   label: "Mapped To Teacher",
    //   options: {
    //     filter: false,
    //     filterType: "dropdown",
    //   },
    // },
    {
      name: "student_age",
      label: "Student Age",
      options: {
        filter: false,
        filterType: "dropdown",
      },
    },
    {
      name: "education",
      label: "Education",
      options: {
        filter: false,
        filterType: "dropdown",
      },
    },

    // {
    //   name: "audio_status",
    //   label: "Audio Status",
    //   options: {
    //     filter: true,
    //     filterType: "checkbox",
    //     customBodyRender: (value, data) => {
    //       // console.log(data);
    //       if(data.rowData[14] === "active"){
    //         let obj = {};

    //         switch(value){
    //           case "approved":
    //             Object.assign(obj, {title: "Audio Approved", style: {color: "#2D8E0F"}, isDisable: false});
    //             break;
    //           case "rejected":
    //             Object.assign(obj, {title: "Audio Rejected", style: {color: "#E35252"}, isDisable: false});
    //             break;
    //           case "resend":
    //             Object.assign(obj, {title: "Audio Resend", style: {color: "#CC8B11"}, isDisable: false});
    //             break;
    //           case "submitted":
    //             Object.assign(obj, {title: "Audio Submitted", style: {color: "#d500f9"}, isDisable: false});
    //             break;
    //           default:
    //             Object.assign(obj, {title: "Audio Not Submitted", style: {color: "#9B9B9B"}, isDisable: true});
    //             break;
    //         }

    //         return (
    //           <IconButton onClick={() => !obj.isDisable && setOpenAudioModal(true)}>
    //             <Tooltip aria-label={value} title={obj.title} arrow placement="bottom">
    //               <AudioFileIcon sx={obj.style} />
    //             </Tooltip>
    //           </IconButton>
    //         );
    //       }else{
    //         return(
    //           <IconButton>
    //             <Tooltip title="Teacher Inactive" arrow placement="bottom">
    //               <AudioFileIcon sx={{color: "#9B9B9B"}} />
    //             </Tooltip>
    //           </IconButton>
    //         )
    //       }
    //     },
    //   },
    // },
    {
      label: "Audio status",
      name: "audio_status",
      options: {
        filter: true,
        filterType: "checkbox",
        customBodyRender: (value, data) => {
          // console.log(data);
          let studentId = data.rowData[0];
          let isStudentActive = data.rowData[12];

          if(isStudentActive === "active"){
            let obj = {};

            switch(value){
              case "approved":
                Object.assign(obj, {title: "Audio Approved", style: {color: "#2D8E0F"}, isDisable: false});
                break;
              // case "rejected":
              //   Object.assign(obj, {title: "Audio Rejected", style: {color: "#E35252"}, isDisable: false});
              //   break;
              // case "resend":
              //   Object.assign(obj, {title: "Audio Resend", style: {color: "#CC8B11"}, isDisable: false});
              //   break;
              // case "submitted":
              //   Object.assign(obj, {title: "Audio Submitted", style: {color: "#d500f9"}, isDisable: false});
              //   break;
              case "pending":
                Object.assign(obj, {title: "Action required", style: {color: "#03a9f4"}, isDisable: false});
                break;
              default:
                Object.assign(obj, {title: "Audio Not Submitted", style: {color: "#9B9B9B"}, isDisable: false});
                break;
            }

            return (
              <StudentAudioModal onCloseCallback ={handleCommentsModalClose} iconStatus={obj} studentId={studentId}/>
            );

          }else{
            return (
              <StudentAudioModal iconStatus={{title: "Student inactive", style: {color: "#9B9B9B"}, isDisable: true}} studentId={studentId}/>
            );
          }
          
        }
      },
    },
    /*Adding comments column here*/
    {
      name: "stud_comments",
      label: "Comments",
      options: {
        filter: false,
        filterType: "dropdown",
        customBodyRender :(value) =>{
          // console.log(value);
          return (
            <ShowFullText title={value}>
             <Typography variant='p' sx={{ cursor:'pointer'}}>
              {value && value.length> 25? `${value.substring(0,25)}...` : value}
             </Typography>
            </ShowFullText>
          )
        }
      },
    },
    {
      name: "student_status",
      label: "Student Status",
      options: {
        filter: true,
        filterType: "checkbox",
        customBodyRender: (value) => {
          return (
            <div>
              {value === "active" ? (
                <div
                  style={{
                    backgroundColor: "green",
                    color: "white",
                    padding: "5px",
                    borderRadius: "5px",
                    opacity: "0.75",
                    textAlign: "center",
                  }}
                >
                  Active
                </div>
              ) : value === "inactive" ? (
                <div
                  style={{
                    backgroundColor: "blue",
                    color: "white",
                    padding: "5px",
                    borderRadius: "5px",
                    opacity: "0.75",
                    textAlign: "center",
                  }}
                >
                  Inactive
                </div>
              ) : (
                <div
                  style={{
                    backgroundColor: "red",
                    color: "white",
                    padding: "5px",
                    borderRadius: "5px",
                    opacity: "0.75",
                    textAlign: "center",
                  }}
                >
                  Drop
                </div>
              )}
            </div>
          );
        },
      },
    },
    {
      name: "ACTIONS",
      options: {
        filter: false,
        sort: false,
        empty: true,
        customBodyRender: (dataIndex, dataValue, rowData, value) => {
          // console.log(dataValue.rowData);
          const unMapped = dataValue.rowData[7] === "mapped"
          const deleted =  dataValue.rowData[12] === "deleted"
          const showDeleteOption = !unMapped && !deleted;
          // console.log(showDeleteOption, "1");
          // console.log(deleted);
          return (
            <div>
              <Dropdown>
                <Dropdown.Toggle
                  variant="primary rounded-circle"
                  id="dropdown-basic"
                >
                  <MoreVertIcon />
                </Dropdown.Toggle>

                <Dropdown.Menu>
                  <Dropdown.Item href="#" onClick={() => setCommentModal(true)}>
                    Create / View comment
                  </Dropdown.Item>
                  {showDeleteOption && (
                    <Dropdown.Item href="#" onClick={() => setDeleteModal(true)}>
                    Drop
                  </Dropdown.Item> 
                  ) 
                 
                
                }
                 

                  {/* <Dropdown.Item
                    href="#"
                    onClick={() => alert("Create Mapping")}
                  >
                    Create Mapping
                  </Dropdown.Item>

                  <Dropdown.Item href="#" onClick={() => alert("Unmapping")}>
                    Unmapping
                  </Dropdown.Item>

                  <Dropdown.Item
                    href="#"
                    onClick={() => alert("Manual Mapping")}
                  >
                    Manual Mapping
                  </Dropdown.Item>

                  <Dropdown.Item
                    href="#"
                    onClick={() => alert("Create Comment")}
                  >
                    Create Comment
                  </Dropdown.Item> */}
                </Dropdown.Menu>
              </Dropdown>
            </div>
          );
        },
      },
    },
  ];

  

  // * Function Call
  useEffect(() => {
    // ? Get Method : Get Method : Fetch All Students Data from the Server
    const controller = axios.CancelToken.source();
    (async () => {
      try {
        let options = {
          method: "GET",
          url: `/student/view/studentview`,
          auth: true,
          data: null,
          token:{cancelToken: controller.token}
        };

        const response = await Axios(
          options.method,
          options.url,
          options.auth,
          options.data,
          options.token,
        );
      response.data.length !== 0 ? setStudentsData(response.data) : setIsDataFetchError(true)
        
      } catch (error) {
        if (!axios.isCancel(error)) {
          setIsDataFetchError(true)
          dispatch(
            showSnackbar({
              message: "Couldn't able to retrieve student data",
              severity: "error",
            })
          );
        }
        }
    })()
    return () => {
      controller.cancel();
    }
  }, [dispatch, reloadComments, rowsPerPage]);

  // * Options Initialization
  const options = {
    textLabels: {
      body: {
        noMatch: isDataFetchError ? "Sorry, No Data available" : <CircularProgress />,
      }
    },

    filter: true,
    filterType: "dropdown",
    responsive: "standard",
    elevation: 0,
    rowsPerPage: rowsPerPage,
    rowsPerPageOptions: [5, 10, 20],
    onChangeRowsPerPage: handleRowsPerPageChange ,
    fixedHeader: true,
    fixedSelectColumn: true,
    tableBodyHeight: "auto",
    jumpToPage: true,
    onRowClick: (rowData) => {
      setTableData(rowData);
    },
    customSearch: (searchQuery, currentRow, columns) => {
      currentRow.forEach(col => {
        if (col && col.toString().indexOf(searchQuery) >= 0) {
          return setIsDataFetchError(true);
        }
      });
    }
  };

  const CustomChip = ({ label, onDelete }) => {
    return (
      <Chip
        variant="outlined"
        color="secondary"
        label={label}
        onDelete={onDelete}
      />
    );
  };

  const CustomFilterList = (props) => {
    return <TableFilterList {...props} ItemComponent={CustomChip} />;
  };
 
  return (
    <div>
      {/* Table */}
      <div style={{ padding: "10px" }}>
        <MUIDataTable
          title={"Overall Students Data"}
          data={studentsData}
          columns={columns}
          options={options}
          components={{
            TableFilterList: CustomFilterList,
          }}
        />
      </div>

      {/* Modal - Overall & Edit */}
      <ModalOpen
        show={nameModal}
        onHide={() => setNameModal(false)}
        tabledata={tableData}
        onCloseCallback ={handleCommentsModalClose}
      />

      {/* Modal - Create comments */}
      <CommentsModalReuse
        show={commentModal}
        onHide={() => setCommentModal(false)}
        // commentstomodal={tableData}
        tabledata={tableData}
        modalname="studentcomments"
        postcomment={"comments/student"}
        getcomment={"comments/student/studentid/"}
        onCloseCallback ={handleCommentsModalClose}
      />

      {/* Modal - Delete */}
      <DeleteStudentModal
        show={deleteModal}
        onHide={() => setDeleteModal(false)}
        tabledata={tableData}
        onCloseCallback ={handleCommentsModalClose}
      />
    </div>
  );
}

export default StudentsTab;
